import React, { useState, useEffect, useCallback } from 'react';
import { InputText, DropdownField } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { Alert } from 'react-bootstrap';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';

const EditSpecificationModal = ({ show, specification, handleClose, handleSave, updating, errors, requestError, productOptions }) => {
  const [formValues, setFormValues] = useState(specification);
  const { handleChange } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(specification);
  }, [specification]);

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: specification?.id });
  }, [formValues, specification?.id, handleSave]);

  return (
    <BaseModalForm show={show} title={specification?.id ? "Editar Especificación" : "Crear Especificación"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-12 form-group">
          <DropdownField
            label="Producto"
            value={formValues?.product_id}
            options={productOptions}
            onChange={(e) => handleChange('product_id', e.target.value)}
            placeholder="Seleccione el producto"
            error={errors.product_id}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="Clave"
            name="key"
            value={formValues?.key}
            onChange={(e) => handleChange('key', e.target.value)}
            placeholder="Ingrese la clave"
            error={errors.key}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="Valor"
            name="value"
            value={formValues?.value}
            onChange={(e) => handleChange('value', e.target.value)}
            placeholder="Ingrese el valor"
            error={errors.value}
          />
        </div>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.SPECIFICATION}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditSpecificationModal);
